export default __webpack_public_path__ + "static/media/massup_background_xl1.e260bee7.jpg";